import { Box } from "@mui/material";

type Props = {
    code: string;
    color?: string;
};

export const DepartmentCodeBadge = ({ code, color }: Props) => {
    return (
        <Box
            sx={{
                width: "max-content",
                minWidth: 36,
                height: 36,
                px: 0.5,
                boxSizing: "border-box",
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 1,
                fontWeight: 700,
                fontSize: 14,
                color: "white",
                backgroundColor: color || "#888",
                textTransform: "uppercase",
                letterSpacing: 1
            }}
        >
            {code}
        </Box>
    );
};